import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminBoxSaleContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeViewed!: boolean;

  @jsonMember(Boolean)
  public readonly canBeEdited!: boolean;

  @jsonMember(Boolean)
  public readonly canBeGroupsEdited!: boolean;

  @jsonMember(Boolean)
  public readonly canBeDeleted!: boolean;

  @jsonMember(Boolean)
  public readonly canBeApproved!: boolean;

  @jsonMember(Boolean)
  public readonly canBeArchived!: boolean;

  @jsonMember(Boolean)
  public readonly canPublicContent!: boolean;

  @jsonMember(Boolean)
  public readonly canHideContent!: boolean;

  @jsonMember(Boolean)
  public readonly canBeWarehouseGoodIdEdited!: boolean;

  @jsonMember(Boolean)
  public readonly canBeBoxViewed!: boolean;
}
